import { ArrowRight, Calendar, MapPin, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import ZeegBookingButton from "@/components/booking/ZeegBookingButton";
const OutdoorCoachingSection = () => {
  return <section className="py-12 md:py-24 bg-[#E1EEDA]"> {/* Slightly enhanced natural green background */}
      <div className="container px-4 sm:px-6 md:px-8">
        <div className="max-w-3xl mx-auto mb-8 md:mb-12 text-center">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm text-center">
            Coaching in der Natur
          </span>
          <h2 className="mb-4 text-center">
            Outdoor-Coaching am Rothsee
          </h2>
          <p className="text-joerg-600 text-left">
            Erleben Sie Coaching in einer inspirierenden Naturkulisse – für neue Perspektiven und frische Gedanken.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 p-6 md:p-8 border-2 border-[#B6D0AE]"> {/* Slightly darker border for better contrast */}
          <div className="md:flex gap-8 items-center">
            <div className="md:w-3/5 text-left mb-6 md:mb-0">
              <div className="flex items-start gap-3 mb-4">
                <div className="flex items-center justify-center mt-1">
                  <MapPin className="w-5 h-5 text-[#2F855A]" />
                </div>
                <p className="text-joerg-600 text-left">Das Outdoor-Coaching am wunderschönen Rothsee verbindet die Kraft der Natur mit professionellem Coaching. In 90-minütigen Walk & Talk Sessions eröffnen sich neue Blickwinkel auf Ihre finanziellen Themen.</p>
              </div>
              
              <div className="pl-8 mb-6">
                <ul className="space-y-2 text-joerg-600 list-disc pl-4 text-left">
                  <li>Bewegung aktiviert Ihr Denken und fördert kreative Lösungen</li>
                  <li>Naturumgebung reduziert Stress und erhöht die Aufnahmefähigkeit</li>
                  <li>Perspektivwechsel durch das Verlassen gewohnter Umgebungen</li>
                </ul>
              </div>
              
              <div className="flex flex-col sm:flex-row justify-start gap-4">
                <ZeegBookingButton className="btn-primary rounded-full inline-flex items-center mobile-touch-target justify-center bg-[#2F855A] hover:bg-[#276749] shadow-md hover:shadow-lg text-white" /* Darker green for button */ text="Erstgespräch vereinbaren" />
                
                <Link to="/outdoor-coaching" className="btn-outline rounded-full inline-flex items-center justify-center border-[#2F855A] text-[#2F855A] hover:bg-[#2F855A]/10">
                  Mehr erfahren
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </div>
            </div>
            
            <div className="md:w-2/5 text-center bg-[#F7FBF4] p-5 rounded-lg border border-[#B6D0AE]/50">
              <div className="text-[#2F855A] font-medium uppercase text-sm mb-2">Ihr Investment</div>
              <div className="text-3xl font-bold text-[#2F855A] mb-1">199 €</div>
              <div className="text-joerg-600 text-sm mb-4">pro 90-Min. Session</div>
              <div className="flex items-center justify-center gap-2 text-sm text-joerg-600 mb-4">
                <Calendar className="w-4 h-4 text-[#2F855A]" />
                <span>Termine nach Vereinbarung</span>
              </div>
              <a href="https://zeeg.me/joerghoermann" target="_blank" rel="noopener noreferrer" className="text-[#2F855A] text-sm hover:underline inline-flex items-center justify-center">
                Direkt buchen <ExternalLink className="ml-1 w-3 h-3" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-joerg-500">Preis inkl. 19% MwSt. gemäß §19 UStG.</p>
        </div>
      </div>
    </section>;
};
export default OutdoorCoachingSection;